import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NotifyService } from '@app/services';
import { TranslateService } from '@ngx-translate/core';
import { PayrollResources } from '../payroll.resources';

interface SevenShiftsConversionResponse {
    data: {
        type: 'sevenShiftsConversion';
        attributes: {
            fileBase64: string;
            filename: string;
            unmatchedTemplateEmployees: string[];
            extraSevenShiftsEmployees: string[];
        };
    };
}

export interface SevenShiftsConversionWarnings {
    unmatchedTemplateEmployees: string[];
    extraSevenShiftsEmployees: string[];
}

@Injectable()
export class SevenShiftsConverterService {
    constructor(
        private http: HttpClient,
        private notify: NotifyService,
        private translate: TranslateService
    ) {}

    async convert(payrollId: number, file: File): Promise<SevenShiftsConversionWarnings> {
        const formData = new FormData();
        formData.append('seven_shifts_file', file);
        const url = PayrollResources.SevenShiftsConvert.replace(':payrollId', payrollId.toString());

        const response = await this.http.post<SevenShiftsConversionResponse>(url, formData).toPromise();

        const { fileBase64, filename, unmatchedTemplateEmployees, extraSevenShiftsEmployees } =
            response.data.attributes;
        this.triggerDownload(fileBase64, filename);
        this.notify.success(this.translate.instant('payroll.run.sevenShiftsConversionSuccess'));
        return {
            unmatchedTemplateEmployees: unmatchedTemplateEmployees ?? [],
            extraSevenShiftsEmployees: extraSevenShiftsEmployees ?? [],
        };
    }

    private triggerDownload(fileBase64: string, filename: string): void {
        const bytes = Uint8Array.from(atob(fileBase64), (c) => c.charCodeAt(0));
        const blob = new Blob([bytes], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = filename;
        anchor.click();
        window.URL.revokeObjectURL(url);
    }
}
